import { BaseUrl } from "../../BaseUrl/BaseUrl";
import {
    getApiWithAuthorization,
    postApiWithAuthorization,
    postApiWithoutAuthorization,
} from "../ApiMethod/ApiMethod";

export const FestivalIdolBookingPackageList = async () => {
    const url = `${BaseUrl}/FestivalIdolBookingPackageList`;
    const res = await getApiWithAuthorization(url);
    return res;
};

export const UserWiseFestivalIdolBookingList = async (user_id, params) => {
    const url = `${BaseUrl}/UserWiseFestivalIdolBookingList?UserID=${user_id}`;
    const res = await postApiWithoutAuthorization(url, params);

    return res;
};
export const FestivalIdolBooking = async (params) => {
    const url = `${BaseUrl}/FestivalIdolBooking`;
    const res = await postApiWithoutAuthorization(url, params);

    return res;
};

